/**
 * @deprecated
 * Instead of passing around REACT_QUERY_KEYS, we should export invalidator functions from our react-query hook files
 */
export enum REACT_QUERY_KEYS {
  PAIRINGS = 'Pairings',
  PAIRINGS_V2 = 'PairingsV2',
  PRODUCTS = 'Products',
  PRODUCTS_V2 = 'ProductsV2',
  CUSTOMERS = 'Customers',
  ORDERS = 'Orders',
  CUSTOMER_TAG_GROUP = 'customer tag group',
  CART = 'Cart',
  ALGOLIA = 'Algolia',
  CUSTOMER_ORDERS = 'Customer Orders',
}
